export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14416.72c09537.jpg";